// Module
var code = `<h2>{{title}}</h2>

<p class="contact-subtitle">  {{subtitle}}</p>

<form class="contact-form" data-event-prevent-default="true">

  {{#formFields}}
  <div class="form-field">
    <label for="{{attrId}}">{{label}}</label>
    <input
      id="{{attrId}}"
      name="{{attrName}}"
      type="{{attrType}}"
      placeholder="{{attrPlaceholder}}"
      required="{{attrRequired}}"
  </div>
  {{/formFields}}
  <div class="form-field">
    <label for="contact-message">{{messageLabel}}</label>
    <textarea
      id="contact-message"
      name="message"
      rows="5"
      placeholder="{{attrMessagePlaceholder}}"
      required
    ></textarea>
  </div>

  <div class="form-actions">
    <button class="btn btn-primary"  type="submit">
      Send Message
    </button>
  </div>
</form>
`;
// Exports
module.exports = code;